import * as awilix from 'awilix';
import { ReduxStore } from '../store/redux.store';
import { DIContainerKeys } from './di-container.keys';
import services from '../services'; 

const diContainer = awilix.createContainer({
  injectionMode: awilix.InjectionMode.PROXY
});

diContainer.register({
  ...services,
  [DIContainerKeys.ReduxStore]: awilix.asClass(ReduxStore).singleton(),
});

export default diContainer;
